import { compact } from "core/utils/collections/compact"

const defaultConfig = {
  play: "white",
  accent: "steelblue"
}

export function withPlayButton(config) {
  const params = new URLSearchParams(
    compact({ ...defaultConfig, ...config })
  ).toString()
  return `${process.env.NODE_FUNCTIONS_HOST}/playbutton?${params}`
}
